const clientOperatorActionTypes = [
  'customerAction',
  'operatorAction',
  'transactionalAction',
  'backendAction'
]

export default {
  clientOperatorActionTypes
}
